const UNDERLINE_RTF_REFERENCE = "\\ul";
const STRIKE_RTF_REFERENCE = "\\strike";

class TextDecoration {
    static getRtfDecorationReference(value) {
        if (!value) {
            return "";
        }

        if (typeof value !== "string") {
            return "";
        }

        value = value.toLowerCase();

        if (value === 'underline') {
            return this.getUnderlineReference();
        }

        if (value === 'line-through') {
            return this.getLineThroughReference();
        }

        return "";
    }

    static getUnderlineReference() {
        return ( UNDERLINE_RTF_REFERENCE );
    }
    static getLineThroughReference() {
        return ( STRIKE_RTF_REFERENCE );
    }
}

module.exports = TextDecoration;
